// SuccessPage.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

const SuccessPage = () => {
  console.log("Success Page Loaded");
  const navigate = useNavigate();

  const goToHome = () => {
    navigate("/");
  };
  
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const sessionId = queryParams.get("session_id");
    console.log(sessionId);
    if (sessionId) {
      fetch(`https://atabackend.quindl.com/checkout-session/${sessionId}`)
        .then((response) => {
          if (!response.ok) {
            console.error(`HTTP Error: ${response.status} ${response.statusText}`);
            throw new Error(`Failed to fetch session details: ${response.statusText}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data.payment_status === "paid") {
            toast.success("Payment successful!");
            saveToDb()
          } else {
            console.error("Payment failed. Server response:", data);
            toast.error("Payment Failed.");
          }
        })
        .catch((error) => {
          console.error("Error fetching session details:", {
            message: error.message,
            stack: error.stack,
            sessionId,
          });
          toast.error("An error occurred. Please try again.");
          localStorage.removeItem('membershipData');
        });
    }    
  }, []);

  const saveToDb = async () => {
    const membershipData = JSON.parse(localStorage.getItem('membershipData'));
    try {
      console.log('Submitting membership data:', membershipData);
      const response = await fetch('https://atabackend.quindl.com/membership/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(membershipData),
      });
  
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Submission Error:', errorText);
        throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
      }
  
      const responseData = await response.json();
      console.log('Submission successful:', responseData);
  
      const allowedMemberships = ['Silver-Family', 'Gold-Family'];
      if (allowedMemberships.includes(membershipData?.membershipName)) {
        navigate('/confirmation', {
          state: {
            membershipType: membershipData?.membershipName,
            userId: membershipData?.userId
          }
        });
      } else {
        navigate('/')
      }
      localStorage.removeItem('membershipData');
  
    } catch (err) {
      console.error('Full submission error:', err);
    }
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-green-100">
      <ToastContainer />
      <div className="bg-white shadow-lg rounded-lg p-8 text-center">
        <h1 className="text-3xl font-bold text-green-600 mb-4">Payment Successful!</h1>
        <p className="text-gray-700 mb-6">
          Thank you for your payment. Your transaction has been successfully processed.
        </p>
        <button
          onClick={goToHome}
          className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-full transition-colors"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default SuccessPage;
